export default function createObjectRecorderLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `object:${input.type}` });
    return {
        initializationStarted() {
            return log({ type: "initialization:started" });
        },
        initializationFinished() {
            return log({ type: "initialization:finished" });
        },
        started(recording) {
            return log({
                type: "started",
                details: recording,
            });
        },
        stopped(recording) {
            return log({
                type: "stopped",
                details: recording,
            });
        },
    };
}
